import projectDetailsData from '../data/projectDetails.json';

export const getProject = (project_id) => {
  console.log(`Getting project with id: ${project_id}`);
  return new Promise((resolve) => {
    const project = projectDetailsData.filter((p) => {
      return p.project_id === project_id;
    })[0];
    
    resolve(project);
  });
};

export const getProjectList = () => {
  console.log("Getting project list");
  return new Promise((resolve) => {
    resolve(projectDetailsData);
  });
};